module.exports = __webpack_public_path__ + "static/WorkSans-Regular-08355c52f278f9f008bb500b3269f161.woff";